<form [formGroup]="lotForm">
  <div class="row">
    <ng-content select=".lotType"></ng-content>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label">Lot Number *</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            required
            type="text"
            placeholder="Add Lot Number"
            formControlName="lotNumbers"
            [maxlength]="fieldVeryShortMaxLength"
            [disabled]="lotId"
            [readonly]="lotId"
          />
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="lotForm.controls.lotNumbers"
        ></control-messages>
      </div>
    </div>

    <div
      class="col-md-12"
      *ngIf="auctionData.auctionStatus !== 1 && lotsForDD?.length"
    >
      <div class="form-group input-with-tooltip">
        <label class="form-label"
          >Enter Lot Number after which this new lot should be added</label
        >
        <mat-form-field appearance="outline">
          <mat-select formControlName="lotNumberAfterWhichThisWillBeAdded">
            <mat-option value="" disabled>Select</mat-option>
            <mat-option *ngFor="let item of lotsForDD" [value]="item?.value">{{
              item?.text
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-hint>applicable only when lot closing has not started.</mat-hint>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="lotForm.controls.lotNumberAfterWhichThisWillBeAdded"
        >
        </control-messages>
      </div>
    </div>

    <div
      class="col-md-12"
      *ngIf="
        auctionData.auctionStatus == 1 &&
        getClosingBeginsData(auctionData.endDateTimeUtc)
      "
    >
      <div class="form-group input-with-tooltip">
        <label class="form-label"
          >Enter Lot Number after which this new lot should be added</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="lotNumberAfterWhichThisWillBeAdded"
            [disabled]="isDisabled"
          >
            <mat-option value="" disabled>Select</mat-option>
            <mat-option *ngFor="let item of lotsForDD" [value]="item?.value">{{
              item?.text
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-hint>{{ message }}</mat-hint>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="lotForm.controls.lotNumberAfterWhichThisWillBeAdded"
        >
        </control-messages>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-100">
          <label class="form-label">Description *</label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              required
              placeholder="Enter description"
              formControlName="description"
              [maxlength]="fieldMaxLengthLongest"
            ></textarea>
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.description"
          ></control-messages>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-140">
          <label class="form-label">Location *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              type="text"
              placeholder="Add Location"
              formControlName="location"
              [maxlength]="fieldMaxLength200"
            />
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.location"
          ></control-messages>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-140">
          <label class="form-label">Lot Category *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              type="text"
              placeholder="Add Lot Category"
              formControlName="category"
              [maxlength]="fieldMaxLengthShort"
            />
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.category"
          ></control-messages>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-140">
          <label class="form-label">Consignor</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              placeholder="Add Consignor"
              formControlName="consigner"
              [maxlength]="fieldMaxLengthShort"
            />
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.Consignor"
          ></control-messages>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-140">
          <label class="form-label"
            >Reserve (in {{ auctionData.currencyName }}) *</label
          >
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              type="number"
              min="0.01"
              placeholder="Add Reserve"
              formControlName="reserve"
              [maxlength]="fieldLengthForPrices"
            />
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.reserve"
          ></control-messages>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-140">
          <label class="form-label">Quantity *</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              type="number"
              placeholder="Enter Quantity"
              formControlName="quantity"
            />
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.quantity"
          ></control-messages>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="min-140">
          <label class="form-label"
            >Starting Price/ Opening Price (in
            {{ auctionData.currencyName }}) *</label
          >
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              type="number"
              min="0.01"
              placeholder="Enter Price"
              formControlName="openingPrice"
              [maxlength]="fieldLengthForPrices"
            />
          </mat-form-field>
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="lotForm.controls.openingPrice"
          ></control-messages>
        </div>
      </div>
    </div>
  </div>

  <p class="error-msg my-2" *ngIf="lotForm.invalid && submitting">
    Please resolve error(s) first
  </p>

  <div class="image-popup-wrap pt-4 mt-2">
    <ng-content select=".closeModalButton"></ng-content>

    <ng-container *ngIf="!lotId">
      <button
        type="submit"
        class="btn btn-colored font-15 ml-2"
        [disabled]="publishLoading || loading"
        role="button"
        (click)="addUpdateLot(false)"
      >
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ lotId ? "Update" : "Add" }} Lot
      </button>
    </ng-container>

    <ng-container *ngIf="lotId">
      <button
        type="submit"
        class="btn btn-colored font-15 ml-2"
        [disabled]="loading || publishLoading"
        role="button"
        (click)="addUpdateLot(true)"
      >
        <span
          *ngIf="publishLoading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ lotId ? "Update" : "Add" }} Lot & Publish
      </button>
    </ng-container>
  </div>
</form>
